import { useEffect, useState } from 'react'

/**
 * A ticking "now" expressed in server time. On each new server response we
 * measure the offset between the server's clock and the device clock, so
 * countdowns match the server's deadlines even when the phone clock is wrong.
 */
export function useServerClock(serverTime: string, tickMs = 250): number {
  const [offset, setOffset] = useState(() => Date.parse(serverTime) - Date.now())
  const [now, setNow] = useState(() => Date.now() + offset)

  useEffect(() => {
    setOffset(Date.parse(serverTime) - Date.now())
  }, [serverTime])

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now() + offset), tickMs)
    setNow(Date.now() + offset)
    return () => clearInterval(id)
  }, [offset, tickMs])

  return now
}
